export default __webpack_public_path__ + "static/cn1-db5bcf0e05fc3b97dba80e7f9e86f35a.png";